<template>
  <div class="module-afiliasi">
    <SOSlotBase :container-name="'pencairan-page-content'">
      <template v-slot:title-bar>
        <div>
          <SOTitleBar :page-title="'Pencairan'" :type="'back'" @back="back" />
        </div>
      </template>
      <template v-slot:content>
        <div class="p-x-20 withdraw-content">
          <div class="info-deposit d-grid-1 p-y-16">
            <div>
              <label class="f-14 f-regular f-c-midgrey m-d-0">Dompet Afiliasi</label>
            </div>
            <div>
              <label class="f-bold m-d-0 f-18 f-c-black">{{ saldo | currency }}</label>
            </div>
            <div class="note">  <img src="@/assets/icons/alert-circle-blue.svg" alt=""/>
              <label class="f-12 f-c-blue f-regular m-d-0">
                Anda dapat melakukan tarik tunai <br/> <b>Hanya pada tanggal 1 s/d 4 Disetiap awal Bulan</b></label>
            </div>
          </div>
          <div class="nominal-pencairan p-t-16">
            <div>
              <SOInputNominal
                :title="'Nominal Penarikan'"
                :prefix-left="true"
                :placeholder="'123.456'"
                :disable="withdrawAll"
                :maxValue="getMaxValue"
                :prefix="`Rp`"
                :defaultValue="nominalWithdraw.formatted"
                v-model="nominalWithdraw"
                @input="handleNominalChange($event)"
              />
            </div>
            <div class="withdraw-all p-t-12">
              <label>
                <input type="checkbox" v-model="withdrawAll" />
                <span class="m-l-4 f-c-black f-regular f-16">
                  Tarik Semua
                </span>
              </label>
            </div>
            <div class="note d-grid-1 f-12 f-regular f-c-midgrey">
              <label class="m-d-0">Minimal penarikan Rp 100.000</label>
              <label class="m-d-0">Maksimal penarikan Rp 10.000.000</label>
              <label class="m-t-12 bg-yellow p-x-12 p-y-8"
                >Sisa saldo setelah penarikan: {{ sisaSaldo | currency }}</label
              >
            </div>
          </div>
          <div class="separator m-x-min m-d-16 m-t-16"></div>

          <div class="rekening">
            <SOCardRekening :rekening="rekening" />
          </div>
          <div class="withdraw-btn">
            <SOButton
              :primary="true"
              :full="true"
              :text="'Lakukan Tarik Tunai'"
              :id="`withdraw-btn-request`"
              @action="confirmWithdraw"
              @hook:mounted="onMounted()"
            />
          </div>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

import SOInputNominal from "@/so-components/global/input/SOInputNominal.vue";

import SOCardRekening from "../components/SOCardRekening.vue";

import { moduleName } from "../store/state";

export default {
  name: "WithdrawPage",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOButton,
    SOInputNominal,
    SOCardRekening,
  },
  data() {
    return {
      minWithdraw: 100000,
      defaultMaxVal: 10000000,
      cacheWithdraw: null,
      withdrawAll: false,
      nominalWithdraw: {
        raw: "",
        formatted: "",
      },
    };
  },
  async mounted() {
    await this.init();
  },
  watch: {
    withdrawAll: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal === true) {
          this.cacheWithdraw = this.nominalWithdraw.raw;
          this.nominalWithdraw = {
            raw: this.defaultMaxVal,
            formatted: this.getMaxValue,
          };
        } else {
          this.nominalWithdraw = {
            raw: this.cacheWithdraw,
            formatted: this.cacheWithdraw.toString(),
          };
        }
      }
    },
  },
  computed: {
    ...mapGetters(moduleName, {
      response: "getResponse",
      isFetching: "isFecthing",
      afiliasiSet: "afiliasiSet",
      cashWithdraw: "cashWithdraw",
    }),
    getMaxValue() {
      let maxValue = this.defaultMaxVal < this.saldo ? this.defaultMaxVal : this.saldo;
      return maxValue.toString();
    },
    saldo() {
      return this.afiliasiSet.saldo;
    },
    rekening() {
      return this.afiliasiSet.rekening;
    },
    sisaSaldo() {
      return this.saldo - this.nominalWithdraw.raw;
    },
  },
  methods: {
    ...mapActions({
      getAfiliasi: `${moduleName}/getAfiliasi`,
      getDataRekening: `${moduleName}/getDataRekening`,
      setCashWithdraw: `${moduleName}/setCashWithdraw`,
      getdetailOwner: `${moduleName}/getdetailOwner`,
    }),
    onMounted() {
      let btn = document.getElementById("withdraw-btn-request");
      btn.style.marginTop = "0px";
      btn.style.marginBottom = "0px";
    },
    async init() {
      if (this.saldo <= 0) {
        await this.getAfiliasi();
      }

      if (!this.rekening.namaBank) {
        await this.getDataRekening();
      }

      await this.getdetailOwner();
    },
    back() {
      this.$router.push({ name: "afiliasi.dashboard" });
    },
    handleNominalChange(e) {
      if (e.raw >= this.minWithdraw) {
        this.setCashWithdraw(e.raw);
      }
    },
    confirmWithdraw() {
      if(this.nominalWithdraw.raw < this.minWithdraw){
        this.$toast.error("Penarikan minimal Rp 100.000");

      }else if(!this.rekening.namaBank){
        this.$toast.error("Masukan info rekening anda terlebih dahulu");

      }else{

        this.$router.push({ name: "afiliasi.dashboard.make_withdraw" });
      }

    },
  },
};
</script>
<style scoped src="../styleScope.css"></style>
<style scoped>
.withdraw-content {
  padding-bottom: 75px;
}
.separator {
  width: auto;
}

.info-deposit {
  border-bottom: 1px solid #ededed;
}

.withdraw-all {
  display: flex;
  flex-direction: column;
}

.withdraw-all label {
  display: inline-flex;
  align-items: normal;
}
.withdraw-all label input[type="checkbox"] {
  height: 1.25rem;
  width: 1.25rem;
  border: 1px solid #c8d0dd;
}

.withdraw-btn {
  position: fixed;
  bottom: 75px;
  width: 90%;
  background-color: white;
}

.withdraw-btn div button {
  margin-bottom: 0px;
  margin-top: 0px;
}
</style>
